import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RoundedButton from './Buttons/RoundedButton';
const NextIcon= () => {
    return (
    
    <RoundedButton sx={{padding:0, margin:0}} variant="text" color='black' endIcon={<KeyboardArrowRightIcon fontSize='small'/>}>
  Επόμενο
</RoundedButton>)
}
export default NextIcon